import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'flightTime',
  standalone: true,
})
export class FlightTimePipe implements PipeTransform {
  transform(minutes: number): string {
    if (isNaN(minutes) || minutes < 0) {
      return '0p'; // Handle invalid input gracefully
    }

    const hours = Math.floor(minutes / 60);
    const remainingMinutes = minutes % 60;

    return `${hours}h${remainingMinutes}p`;
  }
}
